import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

const opts = {
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        //cores do Design System - procurar usar somente elas
        //*primary*
        "be-primary-pure": "#17A2B8",
        "be-primary-dark": "#1789A3",
        "be-primary-light": "#34C8DC",
        "be-primary-bg": "#DEF3F4",
        //*success*
        "be-success-pure": "#289642",
        "be-success-dark": "#1F5C2E",
        "be-success-light": "#5CCC76",
        "be-success-bg": "#E0F8E5",
        //*error*
        "be-error-pure": "#BB3838",
        "be-error-dark": "#892B2B",
        "be-error-light": "#D95A5A",
        "be-error-bg": "#F7D1D1",
        //*alert*
        "be-alert-pure": "#D09F02",
        "be-alert-dark": "#A36F05",
        "be-alert-light": "#ECC806",
        "be-alert-bg": "#F4ECD0",
        //*background*
        "be-background-light": "#23657D",
        "be-background-dark": "#1F5A70",
        "be-background-grey": "#F6F8F9",
        //*neutrals*
        "be-white": "#FFFFFF",
        "be-high-light": "#E3E9ED",
        "be-high-medium": "#B1BDC6",
        "be-high-dark": "#84919A",
        "be-low-light": "#62717B",
        "be-low-medium": "#3A4348",
        "be-low-dark": "#232729",
        //*accents*
        "be-accent-cyan": "#69E2F2",
        "be-accent-yellow": "#EDDD87",
        "be-accent-orange": "#EAA682",
        "be-accent-red": "#F38787",
        "be-accent-rose": "#F699E2",
        "be-accent-pink": "#FACBF0",
        "be-accent-lilac": "#D3ACFD",
        "be-accent-blue": "#93A1FF",
        "be-accent-olive": "#A5CA50",
        "be-accent-lime": "#BFFDAC",
        "be-accent-green": "#9CEFB0",

        //cores antigas - objetivo e parar de usar
        background: "#2B7894",
        "background-high": "#23657d",
        "background-higher": "#1A6783",
        "text-on-background": "#ffffff",
        "default-card": "#DEE4E8",
        "be-primary": "#17a2b8",
        "text-on-primary": "#ffffff",
        "scrollbar-thumb": "#fff",
        "be-error": "#FF5252",
        "be-success": "#27AE60",
        "be-warning": "#F39C12",
        "be-warning-lighter": "#FFBF47",
        "be-warning-extra-light": "#F0C37C",
        "be-archived": "#5E35B1",
        "be-archived-lighter": "#8068b0",
        "be-standard-text": "#686A6D",
        "be-surface": "#f1f4f5",
        "be-surface-darker": "#e3e6e8",
        "be-surface-hover": "#e3e7ee",
        "table-filter": "#E3E9ED",
        "be-grey": "#D0D0D0",
        "be-input-icon": "#757575",
        "chart-card": "#1a6783",
        "be-grey-blue": "#7295AD",
        "be-data-table-stripes": "#ffffff",
        "be-dialog-high": "#d3dadd",
        "be-dialog": "#dce3e7",
        "grey-times-button": "#d4d4d4",
        "grey-to-darker": "#686A6D",
        "grey-to-lighter": "#686A6D",
        "medium-grey-to-darker": "#bdbdbd",
        "be-dark-blue-text": "#365870",
        "be-dark-text": "#1F2020",
        "be-navy-background": "#123a6d",
        "card-icon-button": "#23657d",
        "be-light-blue-grey": "#97BAC8",
        "be-request-text": "#34495e",
        "be-request-card": "#f5f5f5",
        "be-request-card-lighter": "#ffffff",
        "be-request-container": "#d8dfe3",
        "be-baby-blue": "#bee5eb",
      },
    },
  },
};

export default new Vuetify(opts);

export { opts };
